<template>
   <div>
    <Header >
      <v-btn small depressed @click="gotoPrint()" color=btns class="ml-4"><span>Foglio ripasso</span></v-btn>
    </Header>
    <v-container>
      <v-row>
        <v-col xs=12 sm=12 md=12>
          <KanjiSheet v-if="kanaData" :kanjiData="kanaData" :styleData="styleData"/>
        </v-col>
        <v-col xs=12 sm="12" md="12">
          <table class="tb" aria-label="Lettura in rōmaji">
            <tr>
              <th class="cfbg" scope="row">Lettura in rōmaji</th><td class='font-weight-bold'><h2>{{setToRomaji(this.tempKana)}}</h2></td>
            </tr>
          </table>
          <div v-if="kanaData" class="mt-2">
            <h3>Esempi</h3>
          <table class="tb" aria-label="Esempi di termini">
            <thead>
            <tr>
            <th class=cfbg scope="col">Termine in kana</th><th class=cfbg scope="col">Termine in kanji</th><th class=cfbg scope="col">Rōmaji</th><th class=cfbg scope="col">Traduzione</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="elem in kanaData.info" :key="elem._id">
              <td>{{elem.kana}}</td>
              <td>{{elem.kanji}}</td>
              <td>{{setToRomaji(elem.kana)}}</td>
              <td>{{elem.ita}}</td>
              </tr>
            </tbody>
          </table>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <Footer />
   </div>
</template>

<script>
import Api from "@/services/Api";
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import KanjiSheet from "@/components/KanjiSheet.vue";
import {toRomaji} from 'wanakana/wanakana';

export default {
  data() {
    return {
      kanaData: null,
      styleData:{
        width:200,
        height:200,
        maskWidth:200*this.$route.params.kana.length,
        kanjiWidth:200*this.$route.params.kana.length,
        frameWidth:200*this.$route.params.kana.length,
        frameHeight:200,
        step:0.02
        },
      tempKana: this.$route.params.kana,
    };
  },
  
  mounted() {
    this.callKana();
  },
  methods: {
    callKana() {
      Api()
        .get("/api/edukanji/kana?keyword=" + this.tempKana, {})
        .then((result) => {
          this.kanaData = new Object();
          this.kanaData.literal = this.tempKana;
          this.kanaData.info = result.data;
          console.log(this.kanaData);
        });
    },
    gotoPrint() {
      if (this.kanaData) {
      return this.$router.push("/kanaPrint/"+this.kanaData.literal)
      }

    },
    setToRomaji(str) {
      return toRomaji(str).replace("ou","ō").replace("uu","ū").replace("aa","ā");
    }
  },
  components: {
      Header,
      Footer,
      KanjiSheet
  }
}
</script>

<style>
.tb {
  border-collapse: separate;
  border-spacing: 2px;
  width:100%;

}
.tb td,.tb th {
  border:1px solid #eeeeee;
  padding:8px;
}
.tb th {
  width:100px;
  color:white;
}
</style>